import Vue from 'vue';
import Vuex from 'vuex';
// store modules
import appointmentStore from '@/store/appointment';
import carlineStore from '@/store/carline';
import dealerStore from '@/store/dealer.js';
import intialStore from '@/store/initial';
import mobileInstallationStore from '@/store/mobile-installation.js';
import productDetailStore from '@/store/product-details';
import productResultsStore from '@/store/product-results';
import productStore from '@/store/products';
import scheduleStore from '@/store/schedule';
import serviceOfferingsStore from '@/store/serviceOfferings';
import cartStore from '@/store/cart';
import contentStore from '@/store/content';
import modalStore from '@/store/modal';
import consumerInfoStore from '@/store/consumer-info';
import searchStore from '@/store/search';
// plugins
import createChatSyncPlugin from '@/store/plugins/chatSync';

Vue.use(Vuex);

/**
 * Shared store configuration - extracted to avoid duplication
 */
const storeModules = {
	appointment: appointmentStore,
	carline: carlineStore,
	cart: cartStore,
	consumerInfo: consumerInfoStore,
	content: contentStore,
	dealer: dealerStore,
	initial: intialStore,
	modal: modalStore,
	productDetail: productDetailStore,
	productResults: productResultsStore,
	products: productStore,
	schedule: scheduleStore,
	serviceOfferings: serviceOfferingsStore,
	mobileInstallation: mobileInstallationStore,
	search: searchStore
};

/**
 * Creates Vuex store with router-dependent plugins (RECOMMENDED)
 *
 * Enables:
 * - Chat sync plugin (auto-syncs dealer code/URLs to Salesforce)
 * - Future router-dependent features
 *
 * @param {VueRouter} router - Vue Router instance
 * @returns {Store} Vuex store with all plugins
 *
 * @example
 * import router from './router';
 * import { createStore } from './store';
 * const store = createStore(router);
 */
export function createStore(router) {
	return new Vuex.Store({
		modules: storeModules,
		plugins: [createChatSyncPlugin(router)]
	});
}

/**
 * Default store export (BACKWARDS COMPATIBILITY ONLY)
 *
 * WARNING: Missing router-dependent plugins!
 * - Chat sync will NOT work
 * - Dealer code/URL updates won't sync to Salesforce
 *
 * Use createStore(router) instead for production.
 * This export exists only for legacy compatibility.
 *
 * @deprecated Use createStore(router) instead
 */
const store = new Vuex.Store({
	modules: storeModules
});

export default store;
